<template>
  <div class="mains">
    <div class="campus">
      教材管理
      <span>></span>
      <router-link to="selfbook">自制教材区</router-link>
      <span>></span>
      <span @click="tiaozhuan_danyuan">编辑课本</span>
      <span>></span>
      <span @click="tiaozhuan_danyuan1">编辑单元</span>
      <span>></span>
      <span @click="tiaozhuan_danyuan2">编辑章节</span>
      <span>></span>
      编辑页面
    </div>
    <div class="xiaoqu moerduo">
      <el-card :span="24" style="">
        <div class="xiaoqu_1">编辑页面</div>
        <div class="shenzhong">
          <i class="img_1">
            <img style="left: -1.44167vw" src="@/assets/img/education-manage/campus/shenzhong.png" alt />
          </i>
          制作点读区域的步骤：1.如果没有图片需要先上传图片
          2.在图片中需要点读的区域单击鼠标拖拽框住相关区域
          3.拖动区域框可以调整位置
        </div>
        <div class="sp_bj">
          <el-row>
            <el-col :span="11" style="width: 40.36458vw">
              <div class="grid-content bg-purple">
                <div class="sp_bt mb-10">
                  {{ diandu_title }}
                  <span>
                    <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                      <button>更换图片</button>
                    </el-upload>
                  </span>
                </div>
                <div class="sp_sp dd_tp">
                  <hotzone v-if="tempImg" :image="tempImg" :zonesInit="zones" @add="handleAdd" @remove="handleRemove1" @change="handleChange">
                  </hotzone>
                  <div v-else>
                    <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                      <i class="el-icon-plus avatar-uploader-icon1"></i>
                    </el-upload>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12" class="sp_fd">
              <div class="grid-content bg-purple-light">
                <div class="sp_bt">
                  点读区域
                  <span class="sp_tishi">
                    请将您要需要的音频文件上传至素材中心，并进行分组整理，自素材中心导入点读需要的音频
                  </span>
                </div>
                <div class="sp_zhizuo"><span class="sp_tishi"> </span></div>
                <div style="height: 88vh; overflow: auto" class="scrollbarStyle">
                  <div class="sp_fdnr" v-for="(item, index) in form" :key="index">
                    <div class="dz-flex-spece mt-10 mb-10">
                      <i>
                        <img src="@/assets/img/education-manage/campus/bitian.png" style="margin-right: 0.3125vw" />
                      </i>
                      <span> 区域 {{ index + 1 }} ：</span>
                      <!-- <el-input
                        placeholder="请输入您的点读区域命名。 如：1-1"
                      ></el-input> -->
                      <span v-if="item.audiourl === null || item.audiourl === ''" class="yingpingbofang1"></span>
                      <audio v-else controls controlsList="nodownload" class="yingpingbofang">
                        <source :src="item.audiourl" type="audio/wav" />
                      </audio>
                      <el-upload class="avatar-uploader" action="#" :disabled="disabled0" :show-file-list="false" :http-request="watchDubSetTime" :before-upload="beforeAvatarUploads">
                        <el-button type="primary" @click="watchDubSetTime1(item)">
                          导入音频
                        </el-button>
                      </el-upload>
                      <i class="el-icon-delete delete0" @click="handleRemove(index)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import hotzone from '@/components/Hotzone';

export default {
  name: 'addBookPageArea',
  components: {
    hotzone,
  },
  data() {
    return {
      addbookId: '',
      UnitId: '',
      Chapter: '',
      Chapters: '',
      diandu_title: '',
      tempImg: '',
      form: [],
      zones: [],
      gh_yp: '',
      disabled0: false,
    };
  },
  methods: {
    // 导入音频（更换）
    watchDubSetTime1(id) {
      // console.log(id)
      this.gh_yp = id.id;
    },
    watchDubSetTime(data) {
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      this.disabled0 = true;

      formData.append('file', data.file);
      formData.append('orgid', orgid);
      formData.append('id', this.gh_yp);
      // console.log(formData)

      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/bookpagearea/updateBookPageAreaAudio',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          this.disabled0 = false;
          if (result.data.code === 0) {
            this.getBookPageById();
            this.$message.success('导入音频成功！');
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          this.disabled0 = false;
          this.$message.error('导入音频错误：' + err);
        });
    },
    getBookPageAreaById() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/bookpagearea/getBookPageAreaById/' + this.gh_yp,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result);
          if (result.data.code === 0) {
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('导入音频失败：' + err);
        });
    },

    // 区域画框
    handleAdd(zone) {
      // zone.url = this.zones.length ? '' : ''
      console.log('add' + JSON.stringify(zone));
      this.zones.push(zone);
    },
    handleRemove1() {},
    handleRemove(index) {
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        console.log('remove' + JSON.stringify(this.zones[index]), index);
        let opZone = this.zones[index];
        let id = opZone.id;
        this.zones.splice(index, 1);
        if (id !== undefined && typeof id !== 'undefined') {
          // update
          this.deleteBookPageArea(id);
        }
      });
    },
    handleChange(zones, index) {
      // console.log('index !== undefined :' + (index !== undefined) + 'type: ' + (typeof (index) !== 'undefined'))
      if (index !== undefined && typeof index !== 'undefined') {
        let opZone = this.zones[index];
        let id = opZone.id;
        console.log(this.zones, index, 'zones');
        console.log(opZone.topPer, opZone.leftPer, 'handleChange');
        if (id !== undefined && typeof id !== 'undefined') {
          // update
          this.updateBookPageArea(opZone);
        } else {
          let topPer = opZone.topPer;
          let leftPer = opZone.leftPer;
          let widthPer = opZone.widthPer;
          let heightPer = opZone.heightPer;
          let coord = topPer + ',' + leftPer + ',' + widthPer + ',' + heightPer;
          if (widthPer > 0.02 && heightPer > 0.02) {
            this.addBookPageArea(coord);
          }
        }
      }
    },
    getZoneStyle(val) {
      return `${(val || 0) * 100}%`;
    },
    handleZoneClick(url) {
      url && window.open(url);
    },

    // 获取页面信息
    getBookPageById() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/bookpage/getBookPageById/' + this.Chapter,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code === 0) {
            this.diandu_title = result.data.data.title;
            this.tempImg = result.data.data.picurl;
            this.form = result.data.data.areaMap.pageList;
            // console.log('this from==' + this.form)
            this.zones = [];
            let tempzones = result.data.data.areaMap.coordinates;
            if (tempzones !== undefined && typeof tempzones !== 'undefined') {
              this.zones = tempzones;
            }
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('获取页面信息失败：' + err);
        });
    },

    // 新增区域
    addBookPageArea(coord) {
      console.log('coord is ' + coord);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/bookpagearea/addBookPageArea',
        method: 'POST',
        data: {
          pageid: this.Chapter,
          areacode: '',
          coordinate: coord,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result);
          console.log('add');
          if (result.data.code === 0) {
            this.getBookPageById();
          } else {
            this.$message.error('操作失败原因：' + result.data.message);
          }
        })
        .catch((err) => {
          this.$message.error('新增区域失败：' + err);
        });
    },

    // 修改区域
    updateBookPageArea(opZone) {
      let topPer = opZone.topPer;
      let leftPer = opZone.leftPer;
      // console.log(topPer, leftPer, 'updateBookPageArea')
      let widthPer = opZone.widthPer;
      let heightPer = opZone.heightPer;
      let coord = topPer + ',' + leftPer + ',' + widthPer + ',' + heightPer;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/bookpagearea/updateBookPageArea',
        method: 'POST',
        data: {
          pageid: this.Chapter,
          id: opZone.id,
          coordinate: coord,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result);
          console.log('update');
          if (result.data.code === 0) {
            this.getBookPageById();
          } else {
            this.$message.error('操作失败原因：' + result.data.message);
          }
        })
        .catch((err) => {
          this.$message.error('新增区域失败：' + err);
        });
    },

    // 删除区域
    deleteBookPageArea(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/bookpagearea/deleteBookPageArea/' + id,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result);
          if (result.data.code === 0) {
            this.getBookPageById();
            console.log('delete');
            window.location.reload();
          } else {
            this.$message.error('操作失败原因：' + result.data.message);
          }
        })
        .catch((err) => {
          this.$message.error('新增区域失败：' + err);
        });
    },

    // 修改页面图片
    updateBookPagePic() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/bookpage/updateBookPagePic',
        method: 'POST',
        data: {
          id: this.Chapter,
          picurl: this.tempImg,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code === 0) {
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('获取页面信息失败：' + err);
        });
    },

    // 上传图片
    handleAvatarSuccess(data) {
      // console.log(data.file, '========handleAvatarSuccess')
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      formData.append('orgid', orgid);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/mini/miniInfo/uploadimage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result);
          if (result.data.code === 0) {
            let url = result.data.data;
            this.tempImg = url;
          } else {
            this.$message.error(result.data.message);
          }
          this.updateBookPagePic();
          // console.log(this.tempImg)
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('系统错误：' + err);
        });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!');
        return false;
      }
      return isJPG | isPNG && isLt2M;
    },

    beforeAvatarUploads(file) {
      // console.log(file)
      // console.log(flieArr)
      const flieArr = file.name.split('.');
      const isMP3 = flieArr[flieArr.length - 1] === 'mp3';
      const isLt2M = file.size / 1024 / 1024 < 100;

      if (!isMP3) {
        this.$message.error('上传音频只能是 MP3 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传音频大小不能超过 100MB!');
        return false;
      }
      return isMP3 && isLt2M;
    },

    tiaozhuan_danyuan() {
      this.$store.commit('addbookId', this.addbookId);
      this.$router.push({ name: 'addBook' });
    },
    tiaozhuan_danyuan1() {
      this.$store.commit('UnitId', this.UnitId);
      this.$store.commit('addbookIdsss', this.addbookId);
      this.$router.push({ name: 'addBookChapter' });
    },
    tiaozhuan_danyuan2() {
      this.$store.commit('Chapter', this.Chapters);
      this.$store.commit('UnitIds', this.UnitId);
      this.$store.commit('addbookIdsss', this.addbookId);
      this.$router.push({ name: 'addBookPageFromChapter' });
    },
  },

  created() {
    if (!this.$store.state.Chapters) {
      this.$router.push({ name: 'addBookPageFromChapter' });
      return this.$message.error('您当前的页面数据获取失败！');
    }

    this.Chapter = this.$store.state.Chapters;
    this.Chapters = this.$store.state.Chapterss;
    this.UnitId = this.$store.state.UnitIdss;
    if (this.$store.state.addbookIdss) {
      this.addbookId = this.$store.state.addbookIdss;
    } else {
      this.addbookId = this.$store.state.addbookIdss1;
    }
    // console.log(this.addbookId)
    this.getBookPageById();
    // this.getBookPageAreaByPageId()
  },

  destroyed() {
    localStorage.removeItem('UnitIdss');
    localStorage.removeItem('addbookIdss1');
    localStorage.removeItem('Chapters');
    localStorage.removeItem('Chapterss');
  },
};
</script>

<style lang="less">
.hz-m-wrap .hz-m-box.hz-m-hoverbox .hz-icon:hover {
  background: none;
}
.hz-m-wrap .hz-m-box .hz-icon {
  display: none;
}

.yingpingbofang1 {
  width: 340px;
  display: inline-block;
}
.yingpingbofang {
  width: 340px;
  height: 40px;
  // margin: 0px 20px;
  // position: relative;
  // top: 14px;
}

.sp_bj {
  .sp_bt {
    span {
      margin-left: 20px;
      button {
        border: none;
        padding: 8px 20px;
        border-radius: 4px;
        color: #fff;
        background: #00a6e6;
        font-size: 12px;
      }
      div {
        display: inline-block;
      }
      :focus {
        outline: -webkit-focus-ring-color auto 0px;
      }
    }
  }
}

.sp_bj {
  .dd_tp {
    width: 740px !important;
    height: auto !important;
    margin-bottom: 20px;
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 0.3125vw;
      cursor: pointer;
      position: relative;
      left: 1.04167vw;
      overflow: hidden;
      .avatar-uploader-icon1 {
        font-size: 100px;
        color: #8c939d;
        width: 722px;
        height: 898px;
        line-height: 898px;
        text-align: center;
      }
    }
  }
  .sp_fd .sp_fdnr {
    .diandu_quyu {
      position: relative;
      .el-input {
        width: 300px;
      }
      .delete0 {
        position: absolute;
        top: 0;
        right: 0;
        padding: 4px;
      }
      .delete0:hover {
        padding: 4px;
        background: rgba(0, 0, 0, 0.8);
        border-radius: 2px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>
